// AboutUs.js (Parent Component)
import React, { useCallback } from "react";
import "./aboutSection.css";
import Icons from "../../../../config/images";
import { useNavigate } from "react-router-dom";

const ImageSection = () => (
  <div className="image-section">
    <img src={Icons.phoneSimulator} alt="Software Development" />
  </div>
);

const CompanyInfo = () => (
  <div className="company-info">
    <h3 className="company-info-title">Who We Are</h3>
    <p className="company-info-sub-title-style">
      With a team of passionate developers, designers, and strategists, we
      specialize in creating transformative digital experiences. Whether it's a
      sleek mobile application, a high-performance website, or a user-friendly
      interface, we ensure every solution is designed to perfection.
    </p>
    <h3 className="company-info-expertise-title">Our Expertise</h3>
    <ul className="company-info-expertise-details-style">
      <li className="company-info-expertise-seperate-details-style">
        <p className="company-info-sub-title-black-text-style">
          Mobile App Development:
        </p>
        <p className="company-info-sub-title-style">
          {" "}
          iOS, Android, and cross-platform apps.
        </p>
      </li>
      <li className="company-info-expertise-seperate-details-style">
        <p className="company-info-sub-title-black-text-style">
          Web Development:
        </p>
        <p className="company-info-sub-title-style">
          {" "}
          Secure websites with modern technologies.
        </p>
      </li>
      <li className="company-info-expertise-seperate-details-style">
        <p className="company-info-sub-title-black-text-style">UI/UX Design:</p>
        <p className="company-info-sub-title-style">
          {" "}
          Intuitive and seamless experiences..
        </p>
      </li>
      <li className="company-info-expertise-seperate-details-style">
        <p className="company-info-sub-title-black-text-style">
          Full-Stack Development:
        </p>
        <p className="company-info-sub-title-style">
          Frontend-to-backend solutions.
        </p>
      </li>
    </ul>
  </div>
);

const AboutUs = () => {
  const navigate = useNavigate();
  const onBtnPress = useCallback(() => {
    navigate("/contact-form");
  }, [navigate]);

  return (
    <div className="about-us-main-container-----">
      <section className="about-us-container----">
        <div className="heading-container">
          <span className="green-line"></span>
          <h4 className="about-us-gray-text-style">About Us</h4>
        </div>
        <h2 className="section-heading">Top Software Development Company</h2>
        <p className="about-us-section-description">
          At BA Code Solution, where innovation meets precision, we are
          committed to delivering exceptional IT solutions that cater to the
          evolving demands of the digital world.
        </p>
        <div className="about-content">
          <CompanyInfo />
          <ImageSection />
        </div>
      </section>

      <div className="cta-button-main-div-about" onClick={onBtnPress}>
        <button className="cta-button-about-touch">Get In Touch</button>
      </div>
    </div>
  );
};

export default AboutUs;
